import * as React from 'react';
import { markdown } from 'markdown';
import  { withStyles } from '@mui/styles';

import {WithStyles, StyleRules} from '@mui/styles';
import LoadingView from '../components/loading-view';
import EmptySet from '../components/empty-set';
import FieldEditView from './field-edit-view';
import * as request from 'superagent';
import DefinitionEditView from './definition-edit-view';
import DefinitionFormController from './definition-form-controller';
import ItemList from './form-item-list';
import { debounce, cloneDeep } from 'lodash';
// import { Field } from '../components/form-def-field';
import  Field  from '../components/form-def-field-fc' 
import { Definition, PredefinedField } from '../lib/types';
import { buildSectionTitle, applyConditional, getValueAtPath, setValueAtPathWithOpts, getFieldFromDefinition } from './helper';
import { Theme } from '@mui/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Renderers from '~common/lib/renderers';
import * as moment from 'moment';
import classNames from 'classnames';
import PortalUser from `~common/lib/portal-user-context`;
import CookieManager from "~common/lib/cookie-manager";
import { merge } from "lodash";
import DefinitionSectionImport  from './definition-section-import';

import {
  Grid,
  Typography,
  IconButton,
  Button,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { timeStamp } from 'console';
import ActionSchedule from 'material-ui/svg-icons/action/schedule';

const styles = (theme: Theme): StyleRules => ({
  container: {
    fontFamily: 'Roboto,Arial,sans-serif;',
    width: '100%',
    display: "flex",
    flexDirection: "column",
  },
  overlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0.8,
    zIndex: 999,
    backgroundColor: '#fff'
  },
  sectionTitle: {
    marginTop: "5px 5px 5px 5px !important",
    paddingBottom: 7,
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.15rem',
    color: '#555',
    margin: '15px 0'
  },
  embeddedSectionTitle: {
    marginTop: 15,
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto,Arial,sans-serif;',
    fontSize: '1.15rem',
    fontWeight: 500,
    color: '#555',
    margin: '15px 0'
  },
  blankTitle: {
    marginTop: 15,
    paddingBottom: 7,
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto,Arial,sans-serif;',
    fontSize: '1.15rem',
    fontWeight: 500,
    color: '#555',
    margin: '15px 0'
  },
  sectionArea: {
    display: 'flex',
    //flexDirection: "row-reverse",
    alignItems: 'baseline'
  },
  dialog: {
    maxWidth: '900px'
  },
  dialogTitle: {
    fontSize: '1.3125rem',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'space-between'
  },
  dialogFieldType: {
    color: '#ccc'
  },
  formArea: {
    paddingLeft: 5,
    paddingRight: 5,
    display: 'flex',
    alignItems: 'stretch',
    flex: 1
  },
  formAreaOutdent: {
    paddingTop: 15,
    paddingRight: 15
  },
  fieldArea: {
    display: 'flex',
    height: "100%"
  },
  formFieldContainer: {
    display: 'flex',
  },
  blankFormLine: {
    padding: '0px !important',
    margin: 0
  },
  paper: {
    boxShadow: "0px 0px 0px #FFFFFF;none"
  },
  itemListPanel: {
    boxShadow: "0px 0px 0px #FFFFFF;none",
    width: "100%",
    marginBottom: 15
  },
  itemListDetails: {
    boxShadow: "0px 0px 0px #FFFFFF;none",
    padding: 0
    // width: "100%"
  },
  summaryPanel: {
    margin: "0px 0px",
    boxShadow: "0px 0px 0px #FFFFFF;none",
    width: "auto",
    fontSize: '1.15rem',
    fontWeight: 500,
    color: '#555',
    fontFamily: 'Roboto,Arial,sans-serif;'
  },
  configIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 5,
    marginLeft: 5,
    fontSize: '0.9rem'
  },
  details: {
    width: "100%",
    height: "100%",
    padding: 5,
    display: 'flex',
  },
  detailsWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  AccordionDetails: {
    width: "100%",
    // padding: 10
  },
  instructions: {
    fontSize: '1rem',
    color: '#303030',
    marginBottom: 30,
    width: "100%"
  },
  errorInstructions: {
    // padding: 15,
    paddingLeft: 15,
    fontSize: '1rem',
    color: '#f44336',
    width: "100%"
  },
  warnInstructions: {
    // padding: 15,
    paddingLeft: 15,
    fontSize: '1rem',
    color: '#ffae42',
    width: "100%"
  },
  historyInstructions: {
    padding: 15,
    fontSize: '1rem',
    color: '#1614b3',
    width: "100%"
  },
  historyArea: {
    display: 'flex',
    //flexDirection: "row-reverse",
    width: 500,
    alignItems: 'center',
    marginLeft: 10
  },
  historyButton: {
    width: 175,
    // bottom: 10,
    right: 225,
    alignItems: 'center',
  },
  historyBack: {
    width: 50,
    alignItems: 'flex-start',
    // bottom: 10,
    flexGrow: 1
  },
  historyStep: {
    alignItems: 'center',
    // bottom: 10,
    flexGrow: 2
  },
  historyForward: {
    width: 50,
    // bottom: 10,
    alignItems: 'flex-end',
    flexGrow: 1
  },
  historyToggleArea: {
    // overflow: 'hidden',
    // margin: '-20px -25px 0px -25px',
    // transition: 'height .25s ease-in-out',
    // position: 'relative'
  },
  historyToggle: {
    bottom: 10,
    right: 225,
    opacity: 0.7
  },
  historyEnable: {
    bottom: 10,
    right: 225,
    opacity: 0.3
  },
  successIcon: {
    color: 'green',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  infoIcon: {
    color: '#005897',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  warnIcon: {
    color: 'gold',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  errorIcon: {
    color: '#f44336',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  actionBar: {
    marginTop: 15
  },
  subDefinitions: {
    display: 'flex',
  },
  subDefinition: {
    // To make subdefinitions fill the parent space
    // flex: 1,
    // To allow children to do the same
    display: 'flex',
    // margin: theme.spacing(2),
    marginBottom: theme.spacing(3)

  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  path: string;
  data: any;
  definition: Definition;
  policyMessages?: Array<any>;
  suppressTitle?: boolean;
  showSectionStatusIcon?: boolean;
  preventCollapse?: boolean;
  onChangeAtPath?: (path: string, newVal: any, fieldProps?: any) => void;
  
  onValidate?: (fieldProps: any, path?: string, reverse?: boolean)  => Promise<any>;
  adminMode?: boolean;
  onDefinitionChange?: (def: Definition) => void;
  onApplyConditional?: (
    basisPath: string,
    conditionalAttribute: any,
    i: any,
    field: PredefinedField
  ) => void;
  // Allows the caller to participate as conditionals are evaluate for form display
  onEvaluateConditional?: (
    fullPath: string,
    conditional: any,
    value: any,
    data: any,
    field: PredefinedField
  ) => any;
  onAccessRootData?: (
    fullPath: string
  ) => any;
  customRenderers?: any;
  emptySetRenderers?: any;
  // coming in on props, this string will be used to replace the title
  titleOverride?: string;
  customMessages?: any;
  // gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  embedded?: boolean;
  // Index of the section to display. If provided only that section will be displayed.
  sectionIDX?: number;
  // readOnly prop for any rendered fields. 
  readOnly?: boolean;
  // Signals the history button should be shown, and is the request URL for the previous versions. Overridden by the historicalURL on the form. 
  historicalURL?: string;
  // Suppresses the history button, regardless of whether the the historicalURL is provided, allowing the same form to be used for, say, check request and invoice view.
  suppressHistory?: boolean;
  // Allows the caller to participate in the file validation process
  onFileReject?: (rejectedFiles: Array<any>) => void;
  handleItemDelete?: any
  // Display message when an invalid definition is returned which can happen with invalid Toekn during registration
  noDefinitionFoundMessage?: string
  triggerAction?: Function
}

// We will kepp internal state to give more options to the consumers, but we will always defer to the data coming from the props.
type State = {
  data: any;
  status: 'ready' | 'loading';
  editField?: any;
  editDefinitionIdx?: any;

  policyMessages?: Array<any>;

  // indicates to the sequence editor to request into the historical search provider, and set the view mode to historical. 
  historicalView?: boolean;
  historyStep?: number;
  // history data and patches. Might not be the way to do it, but allows the history stepper to be snappy. 
  historicalData: any;
  stashedData: any;

  viewState: 'none' | ''
  gridAttributeOverride?: any;
};

interface ConditionalEval {
  exprResult: boolean,
  stopEvaluation: boolean
}

class DefinitionSection extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  ManagedWindows = []

  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});

    this.state = {
      data: this.preProcessData(props.data || {}),
      status: 'loading',
      viewState: ''
    };

    // handleChangeAtPath is used to ferry changes from owned omponents upstream
    this.handleChangeAtPath = debounce(this.handleChangeAtPathRaw, 10)
  }
  

 componentDidMount() {
    // Initiate loading here is any loading is required.  Do not forget to also implement in UNSAFE_componentWillReceiveProps also
    this.setState({ status: 'ready'});
    const self = this;
    window.addEventListener("message", (event) => {
      self.handleMessage(event)
    }, false)
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>,
    oldProps: Props & WithStyles<keyof typeof styles>
  ) {
    // When we get new props, always defer to those over internal state.  This is crucial to the predictable operation of the component parts
    // Initiate loading here is any loading is required.  Do not forget to also implement incomponentDidMount also
    
    var {data, historicalView, policyMessages} = this.state
    // only allow new data and policy messages if we're not in the historical view.
    // The historical data and associated policy messages are internal to this component, 
    // so receiving props causes them to disappear. 
    if (!historicalView) {
      data = this.preProcessData(newProps.data || {})
      policyMessages = newProps.policyMessages
    }

    this.setState({
      data: data,
      policyMessages: policyMessages,
      status: 'ready'
    }, () => {
      if (this.ManagedWindows.length > 0) {
        this.ManagedWindows.forEach((mw: any) => {
          this.handleMessage({ source: mw, data: { "action": "datadidupdate" } })
        })
      }
    });
  }

  // preProcessData is where we can set up minimums establish defaults, etc.
  preProcessData = (data: any): any => {
    return data;
  };

  getFieldDef = (attribute: string): PredefinedField | undefined => {
    const { definition } = this.props;
    if (definition) {
      return definition.getFieldDef(attribute);
    }

    return undefined;
  };

  handleCommitChange = (attribute: string, userDefined?: boolean) => (val: any) => {
    const { path, definition } = this.props;
    const { data } = this.state;


    var fieldDef: any
    if (definition) {
      for (let preDefined of definition.predefined) {
        if (preDefined.key == attribute || preDefined.path == attribute) {
          fieldDef = preDefined
        }
        
      }
      if (!fieldDef) {
        fieldDef = definition.user[attribute]
      }
    }
    
    const alteredField = new PredefinedField(cloneDeep(fieldDef));
    let deepClone = JSON.parse(JSON.stringify(data));

    let svpResp = setValueAtPathWithOpts(path, deepClone, val, null);

    if (alteredField.conditionalAttributes) {
      alteredField.conditionalAttributes.map((attr) => {
        applyConditional(path, attr, svpResp.data, alteredField, this.props.onEvaluateConditional, this.props.onAccessRootData);
      });
    }

    if (alteredField && alteredField.triggerValidationAtURL && alteredField.requireTriggerConfirmation) {
      if (this.props.onChangeAtPath) {
        this.props.onChangeAtPath(path + '/' + attribute, val, alteredField);
      }
    } else {
      if (userDefined) {
        if (!data.extendedAttributes) {
          data.extendedAttributes = {}
        }
        setValueAtPathWithOpts(attribute, data.extendedAttributes, val, null)
      } else {
        setValueAtPathWithOpts(attribute, data, val, null)
      }
      // Update the internal state first, but do not wait.
      this.setState({ data: data });
  
  
      // Let the parent know something changed
      if (this.props.onChangeAtPath) {
        
        this.props.onChangeAtPath(path + '/' + attribute, val, alteredField);
      }
    }
    
  };
  

  handleValidate = (attribute: string, path: string, reverse?: boolean): Promise<any> => { 
    const { definition } = this.props;
    return new Promise((resolve, reject) => {
    
    var fieldDef: any
      if (definition) {
        for (let preDefined of definition.predefined) {
          if (preDefined.key == attribute) {
            fieldDef = preDefined
          }
        }

        if (!fieldDef) {
          fieldDef = definition.user[attribute]
        }
      }
      if (this.props.onValidate) {
        
        this.props.onValidate(fieldDef, path, reverse).then((resp) => {
          resolve(resp);
        });
      }
    })
  };

  handleUserAttributeCommitChange = (attribute: string) => (val: any) => {
    const { path } = this.props;
    const { data } = this.state;
    if (!data['extendedAttributes']) {
      data['extendedAttributes'] = {};
    }
    data['extendedAttributes'][attribute] = val;
    // Update the internal state first, but do not wait.
    this.setState({ data: data });

    // Let the parent know something changed
    if (this.props.onChangeAtPath) {
      this.props.onChangeAtPath(path + '/extendedAttributes/' + attribute, val);
    }
  };


  // handleChangeAtPath is used to ferry changes from owned omponents upstream
  handleChangeAtPathRaw = (path: string, val: any, fieldDef?: any, idx?:number) => {
    const { onChangeAtPath } = this.props;
    if (onChangeAtPath) {
      onChangeAtPath(path, val, fieldDef, idx);
    }
  };

  noopChangeAtPath = (attribute: string, val: any) => { };

  applyConditionalsToDefinition = (definition: any, data: any) => {
    if (definition && definition.predefined) {

      for(let i = 0; i < definition.predefined.length; i++) {
        var localField = definition.predefined[i];
        var path = localField.path || '';
        var pathExt = path + '/';
        
        if (path.length > 0) {
          pathExt = path + '/';
        }
        // if available, apply conditionals
        if (localField.conditionalAttributes) {
          localField.conditionalAttributes.map((attr) => {
            this.handleOnApplyConditional(
              pathExt + localField.key,
              attr,
              data || {},
              localField
            );
          });
        }
      }
    }
  }


  handleOnApplyConditional = (
    basisPath: string,
    conditionalAttribute: any,
    i: any,
    field: PredefinedField
  ) => {
    if (this.props.onApplyConditional) {
      this.props.onApplyConditional(basisPath, conditionalAttribute, i, field);
    } else {
      // We are at the top of the chain
      //applyConditional(this.props.path, conditionalAttribute, i, field, this.props.onEvaluateConditional);
      applyConditional(this.props.path, conditionalAttribute, i, field, this.props.onEvaluateConditional, this.props.onAccessRootData);
    }
  };

  handleFieldConfigClick = (field: any) => (evt: any) => {
    this.setState({ editField: field });
  };
  handleFieldConfigClose = (field: any) => {
    this.setState({ editField: null });
  };

  handleFieldChange = (field: PredefinedField) => {
    const { definition } = this.props;

    let found = false;
    // Find the right field, replace it with the new field and go from there.
    if (definition.predefined) {
      for (var i = 0; i < definition.predefined.length; i++) {
        let f = definition.predefined[i];
        if (f.key == field.key) {
          f = field;
          found = true;
          break;
        }
      }
    }
    if (definition.user) {
      for (var i = 0; i < definition.user.length; i++) {
        let f = definition.user[i];
        if (f.key == field.key) {
          f = field;
          found = true;
          break;
        }
      }
    }

    if (found && this.props.onDefinitionChange) {
      this.props.onDefinitionChange(definition);
    }
  };

  handleFieldDelete = (field: PredefinedField) => () => {
    const { definition, onDefinitionChange } = this.props;

    if (definition.user) {
      definition.user = definition.user.filter(function (f, arrIndex) {
        return f.key !== field.key
      });
    }

    if (onDefinitionChange) {
      onDefinitionChange(definition);
    }

    this.handleFieldConfigClose(field)

  }

  handleDefinitionConfigClick = (idx: any) => (evt: any) => {
    this.setState({ editDefinitionIdx: idx });
  };

  handleDefinitionConfigClose = (field: any) => {
    this.setState({ editDefinitionIdx: null });
  };

  handleDefinitionChange = (def: Definition) => {
    if (this.props.onDefinitionChange) {
      this.props.onDefinitionChange(def);
    }
  };

  handleSubDefinitionChange = (idx: number) => (def: Definition) => {
    const { definition } = this.props;
    definition.definitions[idx] = def;
    this.handleDefinitionChange(definition);
  };

  handleAddNewField = (evt: any) => {
    const { definition } = this.props;
    if (!definition.user) {
      definition.user = [];
    }

    const key = 'userField' + (definition.user.length + 1).toString()
    const title = 'User Field ' + (definition.user.length + 1).toString()

    definition.user.push(new PredefinedField({ key: key, title: title, type: 'Text', mode: 'Optional' }));

    if (this.props.onDefinitionChange) {
      this.props.onDefinitionChange(definition);
    }

  };

  handleHistory = (historicalURL: string) => {
    const self = this

    return function (evt: any) {
      // The stop propogation/prevent default stops the accordian from rolling up when using these buttons
      evt.stopPropagation()
      evt.preventDefault();
      var { data, historicalView } = self.state
      request.post(historicalURL).send(data).then((response: request.Response) => {
        // This historicalURL must be set up for each form, but is always expected to return a slice of "historyPatch"s, which will contain data (whatever data can be set to state), policyMessages (formulated from the patch diffs), and the updated at and updated by of who made the changes reflected in the patch. 
        if (response.body && response.body.historyPatch && response.body.historyPatch[0]) {
          self.setState({
            historicalView: true,
            historyStep: 0,
            historicalData: response.body.historyPatch,
            // Stashed data holds the users changes when going into history mode
            stashedData: cloneDeep(data),
            // data: response.body.historyPatch[0].data, 
            policyMessages: response.body.historyPatch[0].policyMessages
          }, ()=>{
            if (self.props.onHistoryViewToggle) {
              self.props.onHistoryViewToggle(true)
            }
          })
        }
      }).catch((err) => {
        self.handleAPIError(err)
      })
    }

  }

  handleHistoryClose = (evt: any) => {
    var { historicalView, stashedData } = this.state
    evt.stopPropagation()
    evt.preventDefault();
    if (historicalView) {
      this.setState({
        historicalView: false,
        historyStep: 0,
        historicalData: {},
        stashedData: null,
        data: stashedData,
        policyMessages: null
      }, ()=>{
        if (this.props.onHistoryViewToggle) {
          this.props.onHistoryViewToggle(false)
        }
      })
    }

  }


  handleHistoryForward = (evt: any) => {
    var { historyStep, historicalData, stashedData } = this.state
    evt.stopPropagation()
    evt.preventDefault();
    var newStep = historyStep - 1
    if (historicalData[newStep] && historicalData[newStep].policyMessages) {
      if (historicalData[newStep].data) {
        this.setState({
          historyStep: newStep,
          policyMessages: historicalData[newStep].policyMessages,
          data: historicalData[newStep].data
        })

      } else {
        // If there are no further steps forward, we need to revert to the most current set of the data, aka the data that was stashed off the state when history mode was added.
        this.setState({
          historyStep: newStep,
          policyMessages: historicalData[newStep].policyMessages,
          data: stashedData
        })
      }

    }

  }

  handleHistoryBack = (evt: any) => {
    var { historyStep, historicalData } = this.state
    evt.stopPropagation()
    evt.preventDefault();
    var newStep = historyStep + 1
    if (historicalData[newStep] && historicalData[newStep].policyMessages) {
      this.setState({
        historyStep: newStep,
        policyMessages: historicalData[newStep].policyMessages,
        data: historicalData[newStep].data
      })
    }

  }

  handleAPIError = (err: any, terminal?: boolean) => {
    var { policyMessages } = this.state
    try {
      policyMessages = JSON.parse(err.response.text)
    } catch (e) {
      console.error("Error Parsing Policy Messages", e)
    }
    this.setState({
      policyMessages: policyMessages,
      error: err
    })
  };

  getPolicyMessageClass = (policyMessage: any) => {
    const { classes }: { classes: any } = this.props;
    switch (policyMessage.severity) {
      case 1:
        return classes.warnInstructions
      case 2:
        return classes.errorInstructions
      case 4:
        return classes.historyInstructions
      default:
        return undefined
    }
  }

  handleMessage = (message: any) => {
    if (message && message.data) {
      if (this.ManagedWindows.length > 0) {
        switch ((message.data.action || "").toLowerCase()) {
          case "datadidupdate":
            message.source.postMessage({
              action: "datadidupdate",
              data: this.state.data,
            }, window.location.origin);
            break;
          case "ready":
            // The receiving window is ready for initial data
            let msg: any = {
              action: "onReadyStateChange",
              definition: this.props.definition,
              data: this.state.data,
            }
            if (this.props.definition) {
              msg.sourceGridAttributes = JSON.parse(JSON.stringify(this.props.definition.gridAttributes))
            }


            message.source.postMessage(msg, window.location.origin)
            break;
          case "handlechangeatpath":
            // Call internal handlechangeatpath here
            this.props.onChangeAtPath(message.data.data.path, message.data.data.value, message.data.data.fieldDef)
            break;
        }
      } else {
        switch ((message.data.action || "").toLowerCase()) {
          case "reset":
            var { gridAttributeOverride } = this.state
            if (gridAttributeOverride && gridAttributeOverride.original) {
              gridAttributeOverride.current = gridAttributeOverride.original
              this.setState({
                gridAttributeOverride: gridAttributeOverride
              })
            }
            break;
          case "datadidupdate":
            this.setState({
              data: this.state.data
            })
            break;
          case "expand":
            var sga: any = {};
            sga.current = message.data.sectionGridAttributes;
            sga.original = {};

            (this.props.definition.definitions || []).forEach((d: any) => {
              if (sga.current[d.key]) {
                sga.original[d.key] = d.gridAttributes
              }
            })
            this.setState({
              gridAttributeOverride: sga || {}
            })
            break;
        }
      }
    }
  }

  showAsPopout = (key: string) => (event: any) => {
    event.preventDefault();
    const self = this;
    const fn = (event) => {
      self.ManagedWindows.forEach((w) => {
        w.close()
      })
    }

    window.addEventListener("unload", fn);
    this.ManagedWindows.push(window.open("/forms/definition-view", key, "resizable=1,address=no,height=800,width=640,location=no"))
  }




  /*****************************************************************************
 
                                Rendering 
 
  *****************************************************************************/

  render() {

    const { classes }: { classes: any } = this.props;
    const { embedded } = this.props;
    const {
      definition,
      path,
      suppressTitle,
      showSectionStatusIcon,
      preventCollapse,
      adminMode,
      customRenderers,
      gridSpacing,
      emptySetRenderers,
      titleOverride,
      // policyMessages,
      onEvaluateConditional,
      noDefinitionFoundMessage
    } = this.props;


    const {
      status,
      data,
      historicalView,
      historicalData,
      historyStep
    } = this.state;


    const self = this;

    var policyMessages = this.state.policyMessages
    if (!policyMessages) {
      policyMessages = this.props.policyMessages
    }
    console.log("OLD DEF SECTION ")


    if (!definition) {
      return <EmptySet text={noDefinitionFoundMessage || "No Defintion"} />;
    }

    // Check to see if we need to adjust gridAttributes for a popped out window
    if (this.state.gridAttributeOverride && this.state.gridAttributeOverride.current) {
      if (definition && definition.definitions && definition.definitions.length > 0) {
        definition.definitions.forEach((d: any) => {
          if (this.state.gridAttributeOverride.current[d.key]) {
            d.gridAttributes = this.state.gridAttributeOverride.current[d.key];
          }
        })
      }
    }

    const isTitleSuppressed = suppressTitle || definition.suppressTitle

    let popperIcon: any = undefined;
    if ((definition.popperAttributes) && !window.opener) {
      popperIcon = (
        <i onClick={this.showAsPopout(definition.key)} style={{ paddingLeft: 10, paddingRight: 10, cursor: 'pointer' }} className="material-icons ">launch</i>
      )
    }

    var instructions: any = null;
    if (!isTitleSuppressed) {

      var configIcon = (
        <IconButton
          size="large"
          className={classes.configIcon}
          onClick={this.handleDefinitionConfigClick(-1)}>
          <i className={' fa fas fa-cog'} />
        </IconButton>
      );

    }


    // MV: 2021-08-17 Added !definition.allowsMultiples so instructions don't get over displayed
    if (definition.instructions && !definition.allowsMultiples) {
      instructions = (
        <Typography
          className={classes.instructions}
          variant="body1"
          gutterBottom
          dangerouslySetInnerHTML={{ __html: definition.instructions }}
        />
      );
    }

    if (policyMessages && policyMessages.length > 0) {
      // Without this, the instructions from the definition section get cleared so prime it with this:
    
      var policyInstructions:Array<any> = [];
      if (instructions) {
        policyInstructions.push(instructions)
      }

      for (const pm of policyMessages) {
        if (pm.path == path) {
          
          policyInstructions.push(
            <Typography
              className={this.getPolicyMessageClass(pm)}
              variant="body1"
              gutterBottom
              dangerouslySetInnerHTML={{ __html: pm.message }}
            />
          );
        }
      }
      instructions = policyInstructions
    }

    // Here is where we update the field definition by

    if (!data) {
      return;
    }

    switch (status) {
      case 'loading':
        // TODO:
        return <LoadingView classes={{}} />;
        break;

      default:


        var pathExt = path + '/';
        if (path.length > 0) {
          pathExt = path + '/';
        }

        // If we are in admin mode, always show, even if now fields are unhidden
        let isActive = adminMode;

        const fieldBuilder = (userDefined: boolean) => (
          acc: any,
          f: any,
          idx: number
        ): any => {
          let key = 'pf' + idx;

          const localField = new PredefinedField(cloneDeep(f));
          let configIcon: any = null;
          if (f.mode != 'Hidden') {
            isActive = true;
          }

          if (adminMode) {
            let className = ' fa fas fa-cog';
            switch (localField.mode) {
              case 'Required':
                className = ' fa fas fa-asterisk';
                break;
              case 'Optional':
                className = ' fa fas fa-circle-notch';
                break;
              case 'Read Only':
                className = ' fa fas user-slash';
                break;
              case 'Display':
                className = ' fa fas fa-eye';
                break;
              case 'Hidden':
                className = ' fa fas fa-eye-slash';
                break;
            }
            configIcon = (
              <IconButton
                size="large"
                className={classes.configIcon}
                onClick={this.handleFieldConfigClick(f)}>
                <i className={className} />
              </IconButton>
            );
          }

          if (!localField.type) {
            console.warn(
              "reverting to default type 'Text' you should set the field types on the definition in the future",
              localField
            );
            localField.type = 'Text';
            localField.legacy = true;
            f.legacy = true;
          }

          let FieldRenderer = Field;

          //do not use custom renderers in admin mode, since we have preview mode to accomodate that
          if (localField.customRenderer) {

            if (!adminMode && customRenderers) {

              const cr = customRenderers[localField.customRenderer];
              if (cr) {
                FieldRenderer = cr;
              } else {
                let fr = Renderers.find(localField.customRenderer)
                if (fr) {
                  FieldRenderer = fr
                }
  
              }

            } else {

              let fr = Renderers.find(localField.customRenderer)
              if (fr) {
                FieldRenderer = fr
              }

            }

          }


          if (!localField.gridAttributes) {
            localField.gridAttributes = {};
          }

          // if available, apply conditionals
          if (localField.conditionalAttributes) {
            localField.conditionalAttributes.map((attr) => {
              this.handleOnApplyConditional(
                pathExt + localField.key,
                attr,
                data || {},
                localField
              );
            });
          }

          if (f.mode != 'Hidden') {
            isActive = true;
          }

          let val = ""

          if (localField.path) {
            if (localField.userDefined == true) {
              if (!data.extendedAttributes) {
                data.extendedAttributes = {}
              }
              val = getValueAtPath(localField.path, data.extendedAttributes)
            } else {
              val = getValueAtPath(localField.path, data)
            }
          } else {
            if (localField.userDefined == true) {
              if (data.extendedAttributes) {
                val = data.extendedAttributes[localField.key]
              } else {

              }
            } else {
              val = data[localField.key]
            }

          }
          const fr = (
            <div className={classes.formFieldContainer} style={{ position: 'relative', width: '100%'}}>
              <FieldRenderer
                onFileReject={this.props.onFileReject}
                path={localField.path || (pathExt + localField.key)}
                value={val}
                data={data}
                fieldDefinition={localField}
                onCommitChange={self.handleCommitChange((localField.path || localField.key), localField.userDefined)}
                onValidate={this.handleValidate}
                customRenderers={self.props.customRenderers}
                policyMessages={policyMessages}
                showHidden={adminMode}
                readOnly={this.props.readOnly || historicalView}
                onAccessRootData={this.props.onAccessRootData}
                triggerAction={this.props.triggerSubmit}
              />
              {localField.mode === 'Hidden' && (
                <div className={classes.overlay} />
              )}
            </div>
          );

          var hrf = CookieManager.getCookie(
            `hiddenResultsFields|${window.location.pathname}`
          );
      
          var hiddenFields = []
          if (hrf) {
            hiddenFields = hrf.split("|")
          }

          
          
          if(hiddenFields.includes(localField.key) && definition.hidableResults && f.mode == 'Display'){
            var fieldStyleObj = { position: 'relative', width: '100%', display: 'none'}
          }

          if (adminMode || localField.mode != 'Hidden') {
            // If we the field is not hidden at this point, the section is active.
            isActive = true

            if (localField.gridAttributes.newRow) {
              acc.push(
                <Grid
                  key={'nr' + key}
                  className={classes.blankFormLine}
                  item
                  // item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}>
                  {' '}
                </Grid>
              );
            }
            acc.push(
              <Grid
                key={key}
                item
                xs={localField.gridAttributes.xs || 12}
                sm={localField.gridAttributes.sm || 6}
                md={localField.gridAttributes.md || 4}
                lg={localField.gridAttributes.lg || 3}
                xl={localField.gridAttributes.xl || 3}
                style={fieldStyleObj}>
                <div  className={classes.fieldArea}>
                  {configIcon}
                  {fr}
                </div>
              </Grid>
            );
          }
          return acc;
        }; // end field builder func

        let fieldArea: any = null;
        var predefinedFields: Array<any>;
        if (definition.predefined) {
          predefinedFields = definition.predefined.reduce(
            fieldBuilder(false),
            []
          );
        } else {
          predefinedFields = [];
        }

        var userDefinedFields: Array<any> = [];
        if (definition.user) {
          userDefinedFields = definition.user.reduce(fieldBuilder(true), []);
        } else {
          userDefinedFields = [];
        }

        var allFields = predefinedFields.concat(userDefinedFields);

        if (allFields.length > 0) {
          let fieldAreaClass = classes.formArea;
          if (!definition.title && !titleOverride) {
            fieldAreaClass = classes.formAreaOutdent;
          }

          fieldArea = (
            <Grid
              spacing={gridSpacing || 1}
              className={fieldAreaClass}
              container>
              {allFields}
              {adminMode && (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className={classes.actionBar}>
                    <Button
                      color="primary"
                      onClick={this.handleAddNewField}
                      className={classes.button}>
                      Add Field
                    </Button>
                  </div>
                </Grid>
              )}
            </Grid>
          );
        }

        let DefinitionRenderer = DefinitionSectionWithStyles;

        if (definition.customRenderer) {
          var cr
          if (customRenderers) {
            cr = customRenderers[definition.customRenderer];
          } else {
            cr = Renderers.find(definition.customRenderer)
          }
          if (cr) {
            DefinitionRenderer = cr;
            var def = definition
            return (
              <Grid key={def.key} item xl={def.gridAttributes.xl || 12} lg={def.gridAttributes.lg || 12} md={def.gridAttributes.md || 12} sm={def.gridAttributes.sm || 12} xs={def.gridAttributes.xs || 12}>
                <DefinitionRenderer
                  preventCollapse={preventCollapse}
                  key={def.key}
                  path={pathExt}
                  data={data}
                  definition={def}
                  handleItemDelete={this.props.handleItemDelete}
                  adminMode={adminMode}
                  policyMessages={policyMessages}
                  onChangeAtPath={self.handleChangeAtPath}
                  onValidate={self.props.onValidate}
                  onApplyConditional={self.handleOnApplyConditional}
                  onEvaluateConditional={onEvaluateConditional}
                  customRenderers={customRenderers}
                  onAccessRootData={self.props.onAccessRootData}
                  showSectionStatusIcon={this.props.showSectionStatusIcon}
                  gridSpacing={gridSpacing || 1}
                  embedded={embedded}
                  supressTitle
                  readOnly={this.props.readOnly || historicalView}
                  onFileReject={this.props.onFileReject}
                />
              </Grid>
            );
          }
        }

        var definitionsArea: any = null;
        if (
          definition &&
          definition.definitions &&
          definition.definitions.length > 0
        ) {
          // Indicate that something is active so that the definition(section) shows up
          isActive = true;

          var defintionSections = definition.definitions.map(
            (d: any, idx: number): any => {

              if (this.props.sectionIDX != undefined && this.props.sectionIDX != idx) {
                return null
              }

              const def = new Definition(cloneDeep(d));

              if (!def.gridAttributes) {
                // need at least this much so we can used the sizes or defaults
                def.gridAttributes = {}
              }


              if (adminMode) {
                def.minCount = 1;
              }

              if (def.allowsMultiples) {
                if (def.predefined && def.predefined.length > 0) {

                  // run the field builder to see what the fields will look like after conditionals are applied. 
                  predefinedFields = def.predefined.reduce(
                    fieldBuilder(false),
                    []
                  );

                  // if no fields are returned, then they have all been hidden
                  if (predefinedFields.length == 0) {
                    return null
                  }

                  // Add the predefined fields to the definition clone
                  // Also, apply the conditional logic to the fields
                  this.applyConditionalsToDefinition(def, data[def.key] || [])

                }

                var sectionConfigIcon: any = null;
                if (adminMode) {
                  sectionConfigIcon = (
                    <IconButton
                      size="large"
                      className={classes.configIcon}
                      onClick={this.handleDefinitionConfigClick(idx)}>
                      <i className={' fa fas fa-cog'} />
                    </IconButton>
                  );
                }
                const subSectionTitle = buildSectionTitle(
                  classes,
                  def,
                  path,
                  policyMessages,
                  false,
                  showSectionStatusIcon,
                  adminMode,
                  embedded
                );
      
                if (!preventCollapse && !def.singleRecordSelector) { 
                    return (
                      <Grid className={classes.subDefinition} key={"ds_" + def.key + "_" + idx} item xl={def.gridAttributes.xl || 12} lg={def.gridAttributes.lg || 12} md={def.gridAttributes.md || 12} sm={def.gridAttributes.sm || 12} xs={def.gridAttributes.xs || 12}>
                         
                        <Accordion elevation={0} style={def.styleAttributes} defaultExpanded={true} className={classes.itemListPanel}>
                          {subSectionTitle && def.title != "" &&
                            <AccordionSummary tabIndex={-1} className={classes.summaryPanel} expandIcon={<ExpandMoreIcon />}>
                              {subSectionTitle}
                            </AccordionSummary>
                          }
                          {subSectionTitle && def.title == "" &&
                          <div className={classes.blankTitle}>
                            {subSectionTitle}
                          </div>
                              
                          }
                          {def.allowsMultiplesTemplateImportEnabled && <div style={{float: "right"}}>
                            <DefinitionSectionImport definition={def} path={(pathExt + def.key)} handleChangeAtPath={this.handleChangeAtPath} />
                          </div>}
                          {/* Render instructions */}
                          {def.instructions && <FormHelperText><div dangerouslySetInnerHTML={{ __html: def.instructions }}></div></FormHelperText>}

                          <AccordionDetails className={classes.itemListDetails}>
                            <ItemList
                              key={idx}
                              path={pathExt + def.key}
                              definition={def}
                              adminMode={adminMode}
                              readOnly={this.props.readOnly || historicalView}
                              data={data[def.key] || []}
                              multiFormSelector={def.multiFormSelector}
                              onChangeAtPath={self.handleChangeAtPath}
                              singleRecordSelector={def.singleRecordSelector}
                              handleItemDelete={self.props.handleItemDelete}
                              sectionConfigIcon={sectionConfigIcon}
                              emptySetRenderers={emptySetRenderers}
                              suppressTitle
                              classes={{
                                container: classes.container,
                                sectionTitle: classes.subSectionTitle
                              }}
                              policyMessages={policyMessages}
                              itemRenderer={(i: any, idx: number): any => {
                                if (!data[def.key]) {
                                  data[def.key] = [];
                                }

                                return (
                                  <DefinitionRenderer
                                    onFileReject={this.props.onFileReject}
                                    preventCollapse={preventCollapse}
                                    key={def.key + "_" + idx}
                                    path={pathExt + def.key + '/' + idx}
                                    data={data[def.key][idx]}
                                    definition={def}
                                    adminMode={adminMode}
                                    policyMessages={policyMessages}
                                    suppressTitle={true}
                                    onChangeAtPath={self.handleChangeAtPath}
                                    onApplyConditional={self.handleOnApplyConditional}
                                    onAccessRootData={self.props.onAccessRootData}
                                    onValidate={self.props.onValidate}
                                    handleItemDelete={self.props.handleItemDelete}
                                    onEvaluateConditional={onEvaluateConditional}
                                    onDefinitionChange={self.handleSubDefinitionChange(
                                      idx
                                    )}
                                    customRenderers={customRenderers}
                                    gridSpacing={gridSpacing || 1}
                                    embedded={embedded}
                                    readOnly={this.props.readOnly || historicalView}
                                  />
                                );
                              }}
                              gridSpacing={gridSpacing || 1}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    )
                } else {

                  var sectionStyle = {position: 'relative'}

                  sectionStyle = merge(d.styleAttributes, sectionStyle)

                  return (


                    <Grid className={classes.subDefinition} ey={'grid_item_' + idx} item xl={def.gridAttributes.xl || 12} lg={def.gridAttributes.lg || 12} md={def.gridAttributes.md || 12} sm={def.gridAttributes.sm || 12} xs={def.gridAttributes.xs || 12}>
                     
                      <div style={sectionStyle}>
                        <Typography variant="h5" className={classes.sectionTitle}>
                          {subSectionTitle}
                        </Typography>
                        
                        {def.allowsMultiplesTemplateImportEnabled && <div style={{position: "absolute", top: 10, right: 10}}>
                          <DefinitionSectionImport definition={def} path={(pathExt + def.key)} handleChangeAtPath={this.handleChangeAtPath} />
                        </div>}

                        {def.instructions && <FormHelperText><div dangerouslySetInnerHTML={{ __html: def.instructions }}></div></FormHelperText>}

                        <ItemList
                          key={def.key + "_" + idx}
                          path={pathExt + def.key}
                          definition={def}
                          handleItemDelete={self.props.handleItemDelete}
                          adminMode={adminMode}
                          readOnly={this.props.readOnly || historicalView}
                          data={data[def.path || def.key] || []}
                          multiFormSelector={def.multiFormSelector}
                          onChangeAtPath={self.handleChangeAtPath}
                          singleRecordSelector={def.singleRecordSelector}
                          sectionConfigIcon={sectionConfigIcon}
                          emptySetRenderers={emptySetRenderers}
                          suppressTitle
                          classes={{
                            container: classes.container,
                            sectionTitle: classes.subSectionTitle
                          }}
                          policyMessages={policyMessages}
                          itemRenderer={(i: any, idx: number): any => {
                            if (!data[def.key]) {
                              data[def.key] = [];
                            }

                            return (
                              <DefinitionRenderer
                                onFileReject={this.props.onFileReject}
                                preventCollapse={preventCollapse}
                                key={idx}
                                path={pathExt + def.key + '/' + idx}
                                data={data[def.key][idx]}
                                definition={def}
                                adminMode={adminMode}
                                policyMessages={policyMessages}
                                suppressTitle={true}
                                onAccessRootData={self.props.onAccessRootData}
                                onChangeAtPath={self.handleChangeAtPath}
                                onValidate={self.props.onValidate}
                                handleItemDelete={self.props.handleItemDelete}
                                onApplyConditional={self.handleOnApplyConditional}
                                onEvaluateConditional={onEvaluateConditional}
                                onDefinitionChange={self.handleSubDefinitionChange(
                                  idx
                                )}
                                customRenderers={customRenderers}
                                gridSpacing={gridSpacing || 1}
                                embedded={embedded}
                                readOnly={this.props.readOnly || historicalView}
                              />
                            );
                          }}
                          gridSpacing={gridSpacing || 1}
                        />
                      </div>
                    </Grid>
                  )
                }



              } else {
                return (
                  <Grid className={classes.subDefinition} key={'grid_item_' + idx} item xl={def.gridAttributes.xl || 12} lg={def.gridAttributes.lg || 12} md={def.gridAttributes.md || 12} sm={def.gridAttributes.sm || 12} xs={def.gridAttributes.xs || 12}>
                    <DefinitionRenderer
                      preventCollapse={preventCollapse}
                      key={idx}
                      path={pathExt + def.key}
                      data={def.path ? data[def.path] : data[def.key]}
                      definition={def}
                      adminMode={adminMode}
                      policyMessages={policyMessages}
                      onAccessRootData={self.props.onAccessRootData}
                      onChangeAtPath={self.handleChangeAtPath}
                      onValidate={self.props.onValidate}
                      onApplyConditional={self.handleOnApplyConditional}
                      handleItemDelete={self.props.handleItemDelete}
                      onEvaluateConditional={onEvaluateConditional}
                      onDefinitionChange={self.handleSubDefinitionChange(idx)}
                      customRenderers={customRenderers}
                      showSectionStatusIcon={this.props.showSectionStatusIcon}
                      gridSpacing={gridSpacing || 1}
                      embedded={embedded}
                      supressTitle
                      readOnly={this.props.readOnly || historicalView}
                      onFileReject={this.props.onFileReject}
                    />
                  </Grid>
                );
              }
            }
          );

          if (defintionSections.length > 0 && defintionSections.filter((section)=>{return section != null}).length > 0) {
            definitionsArea = (
              <Grid className={classes.subDefinitions}  className={classes.formArea} container>
                {defintionSections}
              </Grid>
            );
          }
        }

        const fieldDialog = this.renderFieldDialog();

        const definitionDialog = this.renderDefinitionDialog();



        let showsHistory = false

        var isTopPath = false
        if (path == "" || path == "/") {
          isTopPath = true
        }

        // HistoricalURL comes off props, unless it is set on the definition section, then the form prop is used instead. 
        var historicalURL = this.props.historicalURL
        var suppressHistory = this.props.suppressHistory || false

        if (definition.historicalURL && definition.historicalURL != "") {
          historicalURL = definition.historicalURL
        }

        // Logic to determine whether the history button is shown. It must be the top level definition, the form must have a historicalURL on the top level, and there must either not be a restrictHistoryToFeature or if present, the user must be logged in and have that feature.  
        if (isTopPath && historicalURL && historicalURL != "" && !suppressHistory) {
          showsHistory = true
          if (definition.restrictHistoryToFeature && PortalUser.isLoggedIn() && !PortalUser.hasOneOfFeatures([definition.restrictHistoryToFeature])) {
            showsHistory = false
          }
        }

        var historyInit = (
          <div className={classes.historyEnable}>
            {!historicalView && showsHistory && (
              <IconButton  className={classes.listFunctionButton} size={"small"} color="primary" aria-label={"Historical View"} onClick={this.handleHistory(historicalURL)} disabled={historicalView}>
                <i className={classNames(classes.historyToggle, 'fa fa-clock')} />
              </IconButton>
            )}
          </div>
        );
        var historyNavigator = (
          <div></div>
        );
        if (historicalView) {
          // Formulates the button label based on the updatedAt and updatedBy of the patch
          var historyLabel
          if (historicalData[historyStep]) {
            var updatedString = ""
            var val = moment(updatedString = historicalData[historyStep].updatedAt);
            if (val.isValid()) {
              val.add(val.toDate().getTimezoneOffset(), 'm');
              updatedString = val.format('MM/DD/YYYY');
            }
            historyLabel = (
              <div>
                <span style={{display:"block"}}>Viewing {historyStep == 0 ? `un-saved changes` : `version ${historicalData[historyStep].data.version}`} {historyStep == 0 ? null : `of ${historicalData.length-1}`}</span>
          
                <span style={{display:"block"}}>Updated at {updatedString} by {historicalData[historyStep].updatedBy}</span>
              </div>
            )
          }


          historyInit = (
            <div></div>
          );
          historyNavigator = (
            <div className={classes.historyArea}>

              {<Button className={classes.historyBack} size={"small"} aria-label="Previous" color="primary" onClick={this.handleHistoryBack} disabled={!historicalData[historyStep + 1]}>
                <i className={classNames(classes.historyToggle, 'fa fa-chevron-left')} />
              </Button>}
              {<Button
                size={"small"}
                aria-label="Close"
                onClick={this.handleHistoryClose}
                className={classes.historyStep}
                disabled={false}>
                {historyLabel}
              </Button>}
              {<Button className={classes.historyForward} size={"small"} aria-label="Next" color="primary" onClick={this.handleHistoryForward} disabled={historyStep <= 0}>
                <i className={classNames(classes.historyToggle, 'fa fa-chevron-right')} />
              </Button>}
            </div>
          );
        }


        if (adminMode || isActive) {
          let definitionClass = classes.container + " " + definition.key
          if (isTitleSuppressed) {
            return (
              <div style={definition.styleAttributes} className={definitionClass}>
                {fieldDialog}
                {definitionDialog}
                <div className={classes.details}>
                  <div className={classes.detailsWrapper}>
                    {instructions}
                    {fieldArea}
                    {definitionsArea}
                  </div>
                </div>
              </div>
            );

          } else {
            // prevent collapse, if requested
            if (!preventCollapse) {

              if (!fieldArea && !definitionsArea) {
                return null
              }
              return (
                <div style={definition.styleAttributes} className={definitionClass}>
                  {fieldDialog}
                  {definitionDialog}
                  <Accordion elevation={0} defaultExpanded={true} className={classes.paper}>
                    {definition.title != null && definition.title != undefined &&  definition.title != "" &&
                    
                      <AccordionSummary tabIndex={-1} className={classes.summaryPanel} expandIcon={<ExpandMoreIcon />}>
                        {titleOverride || definition.title}
                        {historyInit}
                        {historyNavigator}
                        {popperIcon}
                      </AccordionSummary>
                    }
                    <AccordionDetails className={classes.paper}>
                      <div className={classes.AccordionDetails}>
                        <div className={classes.detailsWrapper}>
                          {instructions}
                          {fieldArea}
                          {definitionsArea}
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              );
            } else {

              if (!fieldArea && !definitionsArea) {
                return null
              }

              // Zero should only be used when popping out the window.
              if (definition.gridAttributes.lg != 0) {
                return (
                  <div style={definition.styleAttributes} className={definitionClass}>
                    {fieldDialog}
                    {definitionDialog}
                    {/* {historyButtons} */}
                    {<Typography variant="h5" className={classes.sectionTitle}>
                      {titleOverride || definition.title}
                      {historyInit}
                      {historyNavigator}
                      {popperIcon}
                    </Typography>}
                    <div className={classes.details}>
                      <div className={classes.detailsWrapper}>
                        {instructions}
                        {fieldArea}
                        {definitionsArea}
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (<div />)
              }
            }

          }
        } else {
          return null;
        }
    }
  }

  renderDefinitionDialog = () => {
    const { definition } = this.props;
    const { editDefinitionIdx } = this.state;

    if (
      definition &&
      editDefinitionIdx != undefined &&
      editDefinitionIdx != null
    ) {
      var def: any;
      var defFunc: any;

      if (editDefinitionIdx == -1) {
        def = definition;
        defFunc = this.handleDefinitionChange;
      } else {
        def = definition.definitions[editDefinitionIdx];
        defFunc = this.handleSubDefinitionChange(this.state.editDefinitionIdx);
      }

      if (def) {
        return (
          <Dialog
            open={true}
            fullWidth={true}
            onClose={this.handleDefinitionConfigClose}
            aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">
              {"Edit '" + def.key + "'"}{' '}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>Edit the properties below</DialogContentText>
              <DefinitionEditView
                definition={def}
                onDefinitionChange={defFunc}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleDefinitionConfigClose}
                color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        );
      } else {
        console.error('could not find definition for dialog');
      }
    }

    return null;
  };

  renderFieldDialog = () => {
    const { classes }: { classes: any } = this.props;

    if (this.state.editField) {
      var field = this.state.editField;
      return (
        <Dialog
          maxWidth="lg"
          open={true}
          fullWidth={true}
          onClose={this.handleFieldConfigClose}
          aria-labelledby="form-dialog-title">
          <DialogTitle
            className={classes.dialogTitle}
            id="form-dialog-title">
            <div>{"Edit '" + field.key + "'"}</div>
            <div className={classes.dialogFieldType}>{field.type}</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>Edit the properties below</DialogContentText>
            <FieldEditView
              field={field}
              onFieldChange={this.handleFieldChange}
              onFieldDelete={this.handleFieldDelete}
            />
          </DialogContent>
          <DialogActions>
            {field.userDefined && (
              <Button onClick={this.handleFieldDelete(field)} color="secondary">
                Delete
              </Button>
            )}
            <Button onClick={this.handleFieldConfigClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      );
    }

    return null;
  };
}

export var DefinitionSectionWithStyles = withStyles(styles)(DefinitionSection);
export default DefinitionSectionWithStyles;
